import React from "react";

/**
 * StreakFire — shows a small flame badge next to a Plyx creator's name
 * indicating consecutive-day live streaks.
 *
 *   1–2 days  →  🔥
 *   3–6 days  →  🔥🔥
 *   7+ days   →  🔥🔥🔥
 *
 * Tooltip surfaces the exact count + best-ever. Renders nothing for streak
 * 0 so non-streaking creators don't get a default badge.
 */
const StreakFire = ({ streak = 0, best = 0, size = "sm", className = "" }) => {
  const n = Math.max(0, parseInt(streak, 10) || 0);
  if (n < 1) return null;
  const flames = n >= 7 ? "🔥🔥🔥" : n >= 3 ? "🔥🔥" : "🔥";
  const sizeCls = size === "lg"
    ? "text-base px-2.5 py-1"
    : size === "md"
      ? "text-sm px-2 py-0.5"
      : "text-[11px] px-1.5 py-0.5";
  const title = `${n}-day live streak${best && best > n ? ` · best ${best}` : ""}`;
  return (
    <span
      data-testid="plyx-streak-fire"
      data-streak={n}
      title={title}
      aria-label={title}
      className={`inline-flex items-center gap-0.5 rounded-full bg-gradient-to-r from-[#FF6A00] to-[#FFB42D] text-black font-black tabular-nums ${sizeCls} ${className}`}
    >
      <span className="leading-none">{flames}</span>
      <span className="leading-none">{n}</span>
    </span>
  );
};

export default StreakFire;
